import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment:
    window.location.hostname === 'localhost' ? 'localhost' : import.meta.env.VITE_SENTRY_ENV ?? import.meta.env.MODE,
  ignoreErrors: [/i18next::translator: missingKey/i, /device not found/i, /upload aborted/i],
  integrations: defaults => [
    ...defaults,
    Sentry.feedbackIntegration({ autoInject: false }),
    // @ts-ignore captureConsoleIntegration exists in SDK 10.24+
    Sentry.captureConsoleIntegration({ levels: ['error'] }),
  ],
  enableLogs: true,
  beforeSend(event) {
    try {
      const params = new URLSearchParams(window.location.search);
      const sessionId = params.get('sessionUUID') ?? undefined;
      const treatmentId = params.get('treatmentUUID') ?? undefined;
      if (sessionId || treatmentId) {
        event.tags = { ...(event.tags || {}), sessionId, treatmentId } as any;
      }
    } catch {}
    return event;
  },
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data?.url?.includes('health')) {
      return null;
    }

    return {
      ...breadcrumb,
      data: {
        ...breadcrumb.data,
        appVersion: import.meta.env.VITE_APP_VERSION,
      },
    };
  },
});
